/**
 * У каких значков есть анимированная версия (Noto Animated Emoji, CC-BY 4.0).
 * Файлы лежат в `public/emoji/anim`, 96×96, анимированный webp ~70 КБ.
 *
 * Список короткий НАМЕРЕННО: анимация нужна там, где человек отправляет один
 * значок вместо слов. Тянуть все 1000+ значков по 70 КБ в репозиторий смысла
 * нет — в обычном тексте они всё равно рисуются статичной картинкой.
 * Пополнить: добавить символ в набор в scripts (см. историю коммита) и скачать.
 */
export const ЕСТЬ_АНИМАЦИЯ: Record<string, true> = {
  "1f389": true,
  "1f44c": true,
  "1f44d": true,
  "1f44f": true,
  "1f4aa": true,
  "1f4af": true,
  "1f525": true,
  "1f602": true,
  "1f605": true,
  "1f60d": true,
  "1f60e": true,
  "1f622": true,
  "1f62d": true,
  "1f631": true,
  "1f64c": true,
  "1f64f": true,
  "1f914": true,
  "1f91d": true,
  "1f923": true,
  "1f92f": true,
  "1f970": true,
  "1f973": true,
  "2705": true,
  "2764": true,
};
